<template>
	<section>
		<el-tabs v-model="activeName" type="card">
			<!--open list-->
			<el-tab-pane label="To Confirm" name="first">
				<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
					<el-form :inline="true" :model="filters">
						<el-form-item>
							<el-input v-model="filters.toConfirmFilter" placeholder="Tracking or UPC" clearable @keyup.enter.native="getToConfirmTrackingList">
								<el-button slot="append" icon="el-icon-search" @click="getToConfirmTrackingList"></el-button>
							</el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" v-on:click="showImport">Import</el-button>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" v-on:click="showBulkConfirm">Bulk Confirm</el-button>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" v-on:click="showBulkRemove">Bulk Remove</el-button>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="exportExcel('/excel/exportWarehouseTracking','Tracking.xls',1)">Export</el-button>
						</el-form-item>
					</el-form>
				</el-col>

				<!--列表-->
				<el-table stripe :data="toConfirmList" highlight-current-row v-loading="firstListLoading" style="width: 100%;">
					<el-table-column prop="batchNumber" label="Batch Number" >
					</el-table-column>
					<el-table-column prop="tracking" label="Tracking #" >
						<template slot-scope="scope">
							<p>{{scope.row.tracking}}</p>
							<p class="note">{{scope.row.note}}</p>
						</template>
					</el-table-column>
					<el-table-column prop="upc" label="UPC" >
					</el-table-column>
					<el-table-column prop="qty" label="Qty" width="100px">
					</el-table-column>
					<el-table-column label="Warehouse" >
						<template slot-scope="scope">
							<p v-if="scope.row.isDoctor==0"><i class="fa fa-university"></i>&nbsp;&nbsp;&nbsp;{{scope.row.warehouse}}</p>
							<p v-if="scope.row.isDoctor==1"><i class="fa fa-user"></i>&nbsp;&nbsp;&nbsp;{{scope.row.warehouse}}</p>
						</template>
					</el-table-column>
					<el-table-column prop="createDate" label="Import Date" >
					</el-table-column>
					<el-table-column label="Action">
						<template slot-scope="scope">
							<el-button size="small" type="primary" @click="showEdit(scope.row.cwId)" >Edit
							</el-button>
							<el-button size="small" type="danger" @click="removeTracking(scope.row.cwId)">Remove</el-button>
						</template>
					</el-table-column>
				</el-table>

				<!--工具条-->
				<el-col :span="24" class="toolbar">
					<el-pagination layout="prev, pager, next" @current-change="changeConfirmPage" :page-size="pageSize" :total="toConfirmTotal"
								   style="float:right;">
					</el-pagination>
				</el-col>
			</el-tab-pane>
			<!--Groups list-->
			<el-tab-pane label="Inbound History" name="second">
				<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
					<el-form :inline="true" :model="filters">
						<el-form-item>
							<el-input v-model="filters.historyFilter" placeholder="Name、Tracking or UPC" clearable @keyup.enter.native="getHistoryList">
								<el-button slot="append" icon="el-icon-search" @click="getHistoryList"></el-button>
							</el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" v-on:click="showBulkReverse">Bulk Reverse</el-button>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="exportExcel('/excel/exportWarehouseInboundHistory','inboundHistory.xls',3)">Export</el-button>
						</el-form-item>
					</el-form>
				</el-col>

				<!--列表-->
				<el-table stripe :data="inboundHistory" highlight-current-row v-loading="secondListLoading" style="width: 100%;">
					<el-table-column label="#" prop="cwId">
					</el-table-column>
					<el-table-column prop="productName" label="Shared warehouse inbound" >
						<template slot-scope="scope">
							{{scope.row.productName}} ({{scope.row.lastUpdateDate}})
						</template>
					</el-table-column>
					<el-table-column prop="tracking" label="Tracking" >
					</el-table-column>
					<el-table-column prop="company" label="Company" >
					</el-table-column>
					<el-table-column label="Warehouse" >
						<template slot-scope="scope">
							<p v-if="scope.row.isDoctor==0"><i class="fa fa-university"></i>&nbsp;&nbsp;&nbsp;{{scope.row.warehouse}}</p>
							<p v-if="scope.row.isDoctor==1"><i class="fa fa-user"></i>&nbsp;&nbsp;&nbsp;{{scope.row.warehouse}}</p>
						</template>
					</el-table-column>
					<el-table-column prop="nurseName" label="User" >
					</el-table-column>
					<el-table-column prop="qty" label="Qty">
					</el-table-column>
					<el-table-column prop="forceChargeTime" label="Force Charge Time" v-if="user.userNo == 'user-9aa177023c4340609ce337d618d0bd99' || user.userNo == 'user-bcfde657d5684dd694d89ae424f11530'">
					</el-table-column>
					<el-table-column prop="productStatus" label="productStatus" >
					</el-table-column>
					<el-table-column label="Action" >
						<template slot-scope="scope">
							<el-button size="small" type="primary" @click="editInboundHistory(scope.row)">Edit
							</el-button>
							<el-button size="small" type="danger" @click="reverseById(scope.row.cwId)" v-if="scope.row.productStatus&&scope.row.productStatus.indexOf('Can be reverse')!==-1">
								Reverse
							</el-button>
						</template>
					</el-table-column>
				</el-table>

				<!--工具条-->
				<el-col :span="24" class="toolbar">
					<el-pagination layout="prev, pager, next" @current-change="changeHistoryList" :page-size="pageSize" :total="historyTotal"
								   style="float:right;">
					</el-pagination>
				</el-col>
			</el-tab-pane>

		</el-tabs>

		<el-dialog title="Edit Inbound" width="80%" :visible.sync="editToConfirmInboundVisible"
				   :close-on-click-modal="false">
			<el-form :model="editTracking" label-width="220px" ref="editTracking" :rules="editRule">
				<el-form-item label="Warehouse" prop="warehouseNo">
					<el-select v-model="editTracking.warehouseNo" clearable auto-complete="off">
						<el-option v-for="(warehouse,index) in warehouses" :key="index" :value="warehouse.warehouseNo" :label="warehouse.state+' '+warehouse.city+' '+warehouse.address "></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="Tracking Number" prop="trackingNumber">
					<el-input v-model="editTracking.trackingNumber" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="UPC" prop="upc">
					<el-input v-model="editTracking.upc" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="Qty" prop="qty">
					<el-input-number v-model="editTracking.qty" :min="0" auto-complete="off"></el-input-number>
				</el-form-item>
				<el-form-item label="Note" prop="note">
					<el-input type="textarea" rows="5" v-model="editTracking.note" auto-complete="off"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editToConfirmInboundVisible = false">Close</el-button>
				<el-button type="primary" @click.native="handleEdit" :loading="loading">Submit</el-button>
			</div>
		</el-dialog>

		<!---->
		<el-dialog title="Edit Inbound" width="80%" :visible.sync="editInboundHistoryVisible"
				   :close-on-click-modal="false">
			<el-form :model="editInbound" label-width="220px" ref="editInbound" :rules="editRule">
				<el-form-item label="Product Name">
					<el-input v-model="editInbound.productName" :disabled="true" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="Company">
					<el-input v-model="editInbound.company" :disabled="true" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="Tracking Number">
					<el-input v-model="editInbound.tracking" :disabled="true" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="UPC">
					<el-input v-model="editInbound.upc" :disabled="true" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="Warehouse">
					<el-input v-model="editInbound.warehouse" :disabled="true" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="Qty">
					<el-input-number v-model="editInbound.qty" :min="0" auto-complete="off"></el-input-number>
				</el-form-item>
				<el-form-item label="Note">
					<el-input type="textarea" v-model="editInbound.note" auto-complete="off"></el-input>
				</el-form-item>

			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editInboundHistoryVisible = false">Close</el-button>
				<el-button type="primary" @click.native="editConfirmedTracking" :loading="loading">Submit</el-button>
			</div>
		</el-dialog>

		<!---->
		<el-dialog title="Import" width="80%" :visible.sync="warehouseImportVisible"
				   :close-on-click-modal="false">
			<el-form :model="importTrack"  label-width="220px" :rules="importRule" ref="importTrack">
				<el-form-item >
					<el-button type="primary" @click.native="removeAllItem" :loading="loading">Remove All Tracking</el-button>
					<el-button class="pull-right" type="primary" @click.native="importTracking" :loading="loading">Submit</el-button>
				</el-form-item>
				<el-form-item label="Batch number" prop="batchNumber">
					<el-input v-model="importTrack.batchNumber" :disabled="true" auto-complete="off" :value="batchNumber"></el-input>
				</el-form-item>
				<el-form-item label="Warehouse" prop="warehouseNo">
					<el-select v-model="importTrack.warehouseNo" auto-complete="off" clearable >
						<el-option v-for="(warehouse,index) in warehouses" :key="index" :value="warehouse.warehouseNo" :label="warehouse.state+' '+warehouse.city+' '+warehouse.address "></el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="Tracking Number" prop="trackingNumbers">
					<div v-if="importTrack.trackingNumbers.length>0">
						<el-table stripe :data="importTrack.trackingNumbers" highlight-current-row v-loading="listLoading" style="width: 100%;">
							<el-table-column type="index">
							</el-table-column>
							<el-table-column prop="tracking" label="Tracking Number">
							</el-table-column>
							<el-table-column prop="upc" label="UPC">
							</el-table-column>
							<el-table-column prop="qty" label="Qty">
							</el-table-column>
							<el-table-column prop="note" label="Note">
							</el-table-column>
							<el-table-column label="Action">
								<template slot-scope="scope">
									<el-button size="small" type="danger" @click="removeRow(scope.row)">Remove
									</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div v-else>
						<p style="padding: 0;margin: 0;font-size: 18px;color: #11b95c">You have not uploaded tracking
							number, please upload tracking number.</p>
					</div>
					<p>Import tracking number as
						<el-button size="mini" type="primary" @click="textImportVisible = true">Text</el-button>
						or
						<el-button size="mini" @click="excelImportVisible=true" type="primary">Excel</el-button>
					</p>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="warehouseImportVisible = false">Close</el-button>
				<el-button type="primary" @click.native="removeAllItem" :loading="loading">Remove All Tracking</el-button>
				<el-button type="primary" @click.native="importTracking" :loading="loading">Submit</el-button>
			</div>
		</el-dialog>

		<el-dialog title="Bulk confirm shared warehouse inbound items" width="80%" :visible.sync="bulkConfirmVisible"
				   :close-on-click-modal="false">
			<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
				<el-form :inline="true" :model="filters">
					<el-form-item style="float: right" label="Batch Number :">
						<el-select placeholder="Select a batch number" v-model="batchNumber" @change="changeBatchNumberForBulkConfirm" clearable filterable>
							<el-option  v-for="(b,i) in batchNumbers" :value="b" :label="b" :key="i"></el-option>
						</el-select>
						<el-button type="primary" @click="sendMail">Send Email</el-button>
					</el-form-item>
				</el-form>
			</el-col>
			<el-table stripe :data="bulkConfirmList" highlight-current-row v-loading="listLoading" style="width: 100%;">
				<el-table-column type="index">
				</el-table-column>
				<el-table-column prop="upc" label="UPC" >
				</el-table-column>
				<el-table-column prop="qty" label="Qty" >
				</el-table-column>
				<el-table-column prop="company" label="Company" >
				</el-table-column>
				<el-table-column label="Product" >
					<template slot-scope="scope">
						<el-select v-model="scope.row.productNo" placeholder="select a product">
							<el-option v-for="(p,i) in scope.row.productsList" :key="i" :label="p.productName" :value="p.productNo" ></el-option>
						</el-select>
					</template>
				</el-table-column>
				<el-table-column label="Force Charge Time" v-if="user.userNo == 'user-9aa177023c4340609ce337d618d0bd99' || user.userNo == 'user-bcfde657d5684dd694d89ae424f11530'" >
					<template slot-scope="scope">
						<el-date-picker 
                                    v-model="scope.row.forceChargeTime"
                                    value-format="yyyy-MM-dd"
                                    type="date"
									placeholder="Force Charge Time">
                            </el-date-picker>
					</template>
				</el-table-column>
				<el-table-column label="Action" >
					<template slot-scope="scope">
						<el-button type="danger" @click="removeItem(scope.row)">Remove</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click.native="bulkConfirm" :loading="loading">Bulk Confirm</el-button>
			</div>
		</el-dialog>

		<el-dialog title="Bulk remove shared warehouse inbound items" width="80%" :visible.sync="bulkRemoveVisible"
				   :close-on-click-modal="false">
			<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
				<el-form :inline="true" :model="filters">
					<el-form-item style="float: right" label="Batch Number :">
						<el-select placeholder="Select a batch number" v-model="batchNumber" @change="changeBatchNumberForBulkRemove" clearable filterable>
							<el-option  v-for="(b,i) in batchNumbers" :value="b" :label="b" :key="i"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</el-col>
			<el-table stripe :data="bulkRemoveList" highlight-current-row v-loading="listLoading" style="width: 100%;">
				<el-table-column type="index">
				</el-table-column>
				<el-table-column prop="tracking" label="Tracking #" >
				</el-table-column>
				<el-table-column prop="upc" label="UPC" >
				</el-table-column>
				<el-table-column prop="qty" label="Qty" >
				</el-table-column>
				<el-table-column prop="company" label="Company" >
				</el-table-column>
			</el-table>
			<div slot="footer" class="dialog-footer">
				<el-button type="danger" @click.native="bulkRemove" :loading="loading">Bulk Remove</el-button>
			</div>
		</el-dialog>

		<el-dialog title="Bulk reverse" width="80%" :visible.sync="bulkReverseVisible"
				   :close-on-click-modal="false">
			<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
				<el-form :inline="true" :model="filters">
					<el-form-item style="float: right" label="Batch Number :">
						<el-select placeholder="Select a batch number" @change="changeBatchNumberForBulkReverse" v-model="batchNumber" clearable filterable>
							<el-option  v-for="(b,i) in batchNumbers" :value="b" :label="b" :key="i"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</el-col>
			<el-table stripe :data="bulkReverseList" highlight-current-row v-loading="listLoading" style="width: 100%;">
				<el-table-column type="index">
				</el-table-column>
				<el-table-column label="Shared warehouse inbound" >
					<template slot-scope="scope">
						{{scope.row.productName}} ({{scope.row.lastUpdateDate}})
					</template>
				</el-table-column>
				<el-table-column prop="upc" label="UPC" >
				</el-table-column>
				<el-table-column prop="qty" label="Qty" >
				</el-table-column>
				<el-table-column prop="tracking" label="Tracking" >
				</el-table-column>
				<el-table-column prop="company" label="Company" >
				</el-table-column>
				<el-table-column prop="warehouse" label="Warehouse" >
				</el-table-column>
				<el-table-column prop="forceChargeTime" label="Force Charge Time"  v-if="user.userNo == 'user-9aa177023c4340609ce337d618d0bd99' || user.userNo == 'user-bcfde657d5684dd694d89ae424f11530'">
				</el-table-column>
			</el-table>
			<div slot="footer" class="dialog-footer">
				<el-button type="danger" @click.native="bulkReverse" :loading="loading">Bulk Reverse</el-button>
			</div>
		</el-dialog>

		<el-dialog title="Import tracking number from text" width="80%" :visible.sync="textImportVisible"
				   :close-on-click-modal="false">
			<el-input type="textarea" rows="10" v-model="text" :placeholder="placeholder" auto-complete="off"></el-input>
			<p class="note">The tracking number import of text needs to contain tracking Numbers, upc, quantity, note,
				separated by commas,space or tab, and multiple records must be separated by newline.</p>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="textImportVisible = false">Close</el-button>
				<el-button type="primary" @click.native="importFromText" :loading="loading">Import</el-button>
			</div>
		</el-dialog>

		<el-dialog title="Import tracking number from excel" width="80%" :visible.sync="excelImportVisible"
				   :close-on-click-modal="false">
			<el-upload style="width: 100%;" ref="upload" :on-success="uploadSuccess" :on-error="uploadError" name="filename" drag :action="uploadUrl" :headers="headers" :limit="1" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel">
				<i class="el-icon-upload"></i>
				<div class="el-upload__text"><em>click to upload</em> or drag and drop file</div>
				<div class="el-upload__tip" slot="tip">Only allowed .xls,.xlsx files, please follow the columns format with trackingNum,upc,quantity,note, include the header.</div>
			</el-upload>
		</el-dialog>
	</section>
</template>


<script>
	import util from '../../common/js/util'
	import {getDoctorMembers, getInvitations} from '../../api/memberService';
	import {editInboundTracking,bulkReverse,reverseById,bulkConfirm,getBulkConfirmListByBatchNum,bulkRemove,getBatchNumberList,editTrackingById, getInboundHistoryList, getBatchNumber,getTrackingList,importTracking,getTrackingConfirmList,removeTracking,getTrackingById} from "../../api/inboundService";
	import ElOption from "element-ui/packages/select/src/option";
	import ElInput from "element-ui/packages/input/src/input";
	import {defaultPageSize,serverUrl} from "../../globalVar";
	import {getWarehouseForWarehouseAdmin,sendEmail} from "../../api/warehouseService";
	import {postExportExcel} from "../../api/exportService";

	export default {
		created(){
			this.$on('changeDoctor',(value) => {
				setTimeout(()=>{
					this.getToConfirmTrackingList();
					this.getWarehouses();
					this.getHistoryList();
				},300);
			});
		},
		components: {
			ElInput,
			ElOption},
		data() {
			return {
				text:"",
				warehouses:[],
				headers:{
					Authorization:window.sessionStorage.getItem("authorization")
				},
				uploadUrl:serverUrl+"/multiExcel/batchInboundExcelImport",
				placeholder:"trackNum,upc,quantity,note\r\n" +
						"trackNum,upc,quantity,note",
				currentCompany: "",
				activeName: "first",
				filters: {
					toConfirmFilter:"",
					historyFilter:"",
					name: ''
				},

				batchNumbers:[],
				bulkConfirmList:[],
				bulkRemoveList:[],
				bulkReverseList:[],

				pageSize:defaultPageSize,

				toConfirmPage:1,
				toConfirmTotal:0,

				historyPage:1,
				historyTotal:0,

				firstListLoading:false,
				secondListLoading:false,

				toConfirmList:[],
				confirmInbound: [],
				reportedInbound: [],
				inboundHistory: [],
				total: 0,
				page: 1,
				listLoading: false,

				textImportVisible: false,
				excelImportVisible: false,

				editInbound: {},
				editInboundHistoryVisible: false,//编辑界面是否显示
				editToConfirmInboundVisible:false,
				bulkConfirmVisible:false,
				bulkRemoveVisible:false,
				bulkReverseVisible:false,

				importTrack: {
					warehouseNo: "",
					trackingNumbers: [],
					batchNumber:""
				},
				editTracking:{
					id:"",
					trackingNumber:"",
					upc:"",
					qty:"",
					note:"",
					warehouseNo:""
				},
				batchNumber:"",
				warehouseImportVisible: false,

				editLoading: false,

				addFormVisible: false,//新增界面是否显示
				loading: false,
				importRule: {
					warehouseNo: [
						{required: true, message: 'Warehouse is required.', trigger: 'blur'}
					],
					trackingNumbers: [
						{required: true, message: 'Tracking list is required.', trigger: 'blur'},
						{validator: this.checkTracking,  trigger: 'blur'}
					]
				},
				editRule:{
					trackingNumber:[
						{required: true, message: 'Tracking Number is required.', trigger: 'blur'}
					],
					upc:[
						{required: true, message: 'UPC Number is required.', trigger: 'blur'}
					],
					warehouseNo:[
						{required: true, message: 'Warehouse is required.', trigger: 'blur'}
					]
				},
                user: sessionStorage.getItem('user')

			}
		},
		methods: {
			sendMail(){
				if(this.bulkConfirmList.length>0){
					let upcList = this.bulkConfirmList.filter((item)=>{
						return item.productsList.length==0
					});
					if(upcList.length>0){
						let upcStr = upcList.map((item)=>{
							return item.upc
						}).join(",");
						let param = {
							doctorId:window.sessionStorage.getItem("currentCompany"),
							upc:upcStr
						}
						sendEmail(param).then((data)=>{
							if(data.code==200){
								this.$message.success("Success")
							}
						})
					}else{
						this.$message.error("None unassigned upc founded")
					}
				}else{
					this.$message.error("Empty confirm list.")
				}
			},
			exportExcel(url,fileName,type){
				let param = {
					url:url,
					fileName:fileName,
					doctorNo:window.sessionStorage.getItem("currentCompany"),
					type:type
				}
				postExportExcel(param).then(function(){

				})
			},
			editConfirmedTracking(){
				let param = {
					cwId:this.editInbound.cwId,
					note:this.editInbound.note,
					qty:this.editInbound.qty,
					doctorNo:window.sessionStorage.getItem("currentCompany"),
				};
				this.$confirm("1.reverse the tracking with the original<br>" +
						"2.reUpload Tracking with updated qty", 'Warning', {
					type: 'warning',
					dangerouslyUseHTMLString: true
				}).then(()=>{
					this.loading = true;
					editInboundTracking(param).then((data)=>{
						this.loading = false;
						if(data.status===200){
							this.$message.success(data.message);
							this.getHistoryList();
							this.getToConfirmTrackingList();
							this.editInboundHistoryVisible = false
						}else{
							this.$message.error(data.message);
						}
					})
				}).catch(() => {

				});
			},
			bulkReverse(){
				if(this.batchNumber){
					this.$confirm('Are you sure?', 'Warning', {
						type: 'warning'
					}).then(()=>{
						let param = {
							batchNumber:this.batchNumber,
							doctorNo:window.sessionStorage.getItem("currentCompany")
						};
						this.loading = true;
						bulkReverse(param).then((data)=>{
							this.loading = false;
							if(data.status===200){
								this.$message.success(data.message);
								this.getHistoryList();
								this.getToConfirmTrackingList();
								this.bulkReverseVisible = false;
							}else{
								this.$message.error(data.message);
							}
						})
					}).catch(()=>{})
				}
			},
			reverseById(id){
				this.$confirm('Are you sure?', 'Warning', {
					type: 'warning'
				}).then(()=>{
					this.loading = true;
					let param = {
						cwId:id,
						doctorNo:window.sessionStorage.getItem("currentCompany")
					};
					reverseById(param).then((data)=>{
						this.loading = false;
						if(data.status===200){
							this.$message.success(data.message);
							this.getHistoryList();
							this.getToConfirmTrackingList();
						}else{
							this.$message.error(data.message);
						}
					})
				}).catch(()=>{})
			},
			bulkConfirm(){
				if(this.bulkConfirmList.length===0){
					this.$message.error('Bulk confirm list is empty.');
					return;
				}
				let list = [];
				for(let i=0;i<this.bulkConfirmList.length;i++){
					if(!this.bulkConfirmList[i].productNo){
						this.bulkConfirmList[i].error = true;
					}else{
						this.bulkConfirmList[i].error = false;
						let item = {productNo:this.bulkConfirmList[i].productNo,upc:this.bulkConfirmList[i].upc, forceChargeTime: this.bulkConfirmList[i].forceChargeTime};
						list.push(item);
					}
				}
				let errorList = this.bulkConfirmList.filter((item)=>{
					return item.error;
				});
				if(errorList.length>0){
					this.$message.error('Please select a product for each row.');
					return;
				}
				let param = {
					batchNumber:this.batchNumber,
					doctorNo:window.sessionStorage.getItem("currentCompany"),
					data:list
				};
				this.loading = true;
				bulkConfirm(param).then((data)=>{
					this.loading = false;
					if(data.status===200){
						this.bulkConfirmVisible = false;
						this.bulkConfirmList = [];
						this.batchNumber = "";
						this.getToConfirmTrackingList();
						this.getHistoryList();
					}else{
						this.$message.error(data.message);
					}
				})

			},
			bulkRemove(){
				if(this.batchNumber) {
					this.loading = true;
					let param = {
						batchNumber:this.batchNumber,
						doctorNo:window.sessionStorage.getItem("currentCompany"),
						data:this.toConfirmList
					};
					bulkRemove(param).then((data)=>{
						this.loading = false;
						if(data.status===200){
							this.bulkRemoveVisible = false;
							this.getToConfirmTrackingList();
							this.getHistoryList();
						}else{
							this.$message.error(data.message);
						}
					})
				}else{
					this.$message.error("You must select a batch number before bulk remove.");
				}
			},
			changeBatchNumberForBulkReverse(){
				if(this.batchNumber){
					let param = {
						doctorNo:window.sessionStorage.getItem("currentCompany"),
						batchNumber:this.batchNumber,
						current:1,
						size:99999,
						isReverse:1
					};
					this.listLoading = true;
					getTrackingList(param).then((data)=>{
						this.listLoading = false;
						if(data.status===200){
							this.bulkReverseList = data.result.records;
						}
					})
				}else{
					this.bulkReverseList = [];
				}
			},
			changeBatchNumberForBulkRemove(){
				if(this.batchNumber){
					let param = {
						doctorNo:window.sessionStorage.getItem("currentCompany"),
						batchNumber:this.batchNumber,
						current:1,
						size:99999,
						type:1
					};
					this.listLoading = true;
					getTrackingList(param).then((data)=>{
						this.listLoading = false;
						if(data.status===200){
							this.bulkRemoveList = data.result.records;
						}
					})
				}else{
					this.bulkRemoveList = [];
				}
			},
			changeBatchNumberForBulkConfirm(){
				if(this.batchNumber){
					let param = {
						batchNumber:this.batchNumber,
						doctorNo:window.sessionStorage.getItem("currentCompany"),
						current:1,
						size:99999,
						type:1
					};
					this.listLoading = true;
					getBulkConfirmListByBatchNum(param).then((data)=>{
						this.listLoading = false;
						if(data.status===200){
							let records = [];
							for(let i=0;i<data.result.records.length;i++){
								let record = data.result.records[i];
								if(record.productsList.length===1){
									record.productNo = record.productsList[0].productNo;
								}else{
									record.productNo = "";
								}
								records.push(record);
							}
							this.bulkConfirmList = records;
						}
					})
				}else{
					this.bulkConfirmList = [];
				}
			},
			showBulkReverse(){
				this.getBatchNumberList(3).then(()=>{
					this.batchNumber = "";
					this.bulkReverseList = [];
					this.bulkReverseVisible = true;
				})
			},
			showBulkRemove(){
				this.getBatchNumberList(1).then(()=>{
					this.batchNumber = "";
					this.bulkRemoveList = [];
					this.bulkRemoveVisible = true;
				})
			},
			showBulkConfirm(){
				this.getBatchNumberList(1).then(()=>{
					this.batchNumber = "";
					this.bulkConfirmList = [];
					this.bulkConfirmVisible = true;
				})
			},
			getBatchNumberList(type){
				let param = {
					type:type,
					doctorNo:window.sessionStorage.getItem("currentCompany")
				};
				return getBatchNumberList(param).then((data)=>{
					console.log(data);
					if(data.status===200){
						this.batchNumbers = data.result;
					}else{
						this.$message.error(data.message);
					}
				})
			},
			handleEdit(){
				this.$refs.editTracking.validate((valid)=>{
					if(valid){
						this.loading = true;
						let param = {
							cwId:this.editTracking.id,
							warehouseNo:this.editTracking.warehouseNo,
							tracking:this.editTracking.trackingNumber,
							upc:this.editTracking.upc,
							qty:this.editTracking.qty,
							note:this.editTracking.note
						};
						editTrackingById(param).then((data)=>{
							this.loading = false;
							if(data.status===200){
								this.$message.success(data.message);
								this.getToConfirmTrackingList();
								this.$refs.editTracking.resetFields();
								this.editToConfirmInboundVisible = false;
							}else{
								this.$message.error(data.message)
							}
						})
					}
				});
			},
			showEdit(id){
				getTrackingById({cwId:id}).then((data)=>{
					if(data.status===200){
						this.editTracking.id = data.result.cwId;
						this.editTracking.note = data.result.note;
						this.editTracking.qty = data.result.qty;
						this.editTracking.upc = data.result.upc;
						this.editTracking.warehouseNo = data.result.warehouseNo;
						this.editTracking.trackingNumber = data.result.tracking;
						this.editToConfirmInboundVisible = true;
					}else{
						this.$message.error(data.message);
					}
				})
			},
			removeTracking(id){
				this.$confirm('Are you sure?', 'Warning', {
					type: 'warning'
				}).then(()=>{
					removeTracking({cwId:id}).then((data)=>{
						if(data.status===200){
							this.$message.success(data.message);
							this.getToConfirmTrackingList();
						}else{
							this.$message.error(data.message);
						}
					})
				}).catch(()=>{})
			},
			importTracking(){
				this.$refs.importTrack.validate((valid)=>{
					if(valid){
						this.loading = true;
						let param = {
							batchNumber:this.importTrack.batchNumber,
							doctorNo:window.sessionStorage.getItem("currentCompany"),
							warehouseNo:this.importTrack.warehouseNo,
							data:this.importTrack.trackingNumbers
						};
						importTracking(param).then((data)=>{
							this.loading = false;
							if(data.status===200){
								this.$message.success(data.message);
								this.$refs.importTrack.resetFields();
								this.importTrack.trackingNumbers = [];
								this.warehouseImportVisible = false;
								this.getToConfirmTrackingList();
							}else{
								this.$message.error(data.message);
							}
						})
					}
				})
			},
			checkTracking(rule, value, callback) {
				if (!value.length>0) {
					return callback(new Error('Tracking list is empty.'));
				}else{
					callback();
				}
			},
			uploadSuccess(a){
				if(a.status===200){
					let trackingNumbers = [];
					for(let i=0;i<a.result.length;i++){
						let exsit = trackingNumbers.find((item)=>{
							return item.upc==a.result[i].upc&&item.tracking==a.result[i].trackingNumber&&item.qty==a.result[i].qty;
						});
						if(exsit){
							this.$message.error("Same data exists, please check.");
							this.$refs.upload.clearFiles();
							return;
						}
						trackingNumbers.push({note:a.result[i].note,qty:a.result[i].qty,upc:a.result[i].upc,tracking:a.result[i].trackingNumber});
					}
					this.importTrack.trackingNumbers = trackingNumbers;
					this.excelImportVisible = false;
					this.$refs.upload.clearFiles();
				}else{
					this.$message.error(a.message);
				}
			},
			uploadError(a){
				this.$message.error(a.message);
				this.$refs.upload.clearFiles();
			},
			getWarehouses(){
				getWarehouseForWarehouseAdmin({doctorNo:window.sessionStorage.getItem("currentCompany")}).then((data)=>{
					if(data.code===200){
						this.warehouses = data.records;
					}
				})
			},
			changeConfirmPage(val){
				this.toConfirmPage = val;
				this.getToConfirmTrackingList();
			},
			getToConfirmTrackingList(){
				let param = {
					doctorNo:window.sessionStorage.getItem("currentCompany"),
					current:this.toConfirmPage,
					size:this.pageSize,
					type:1,
					condition:this.filters.toConfirmFilter
				};
				this.firstListLoading = true;
				getTrackingList(param).then((data)=>{
					this.firstListLoading = false;
					if(data.status===200){
						this.toConfirmList = data.result.records;
						this.toConfirmTotal = data.result.total;
					}
				})
			},
			changeHistoryList(val){
				this.historyPage = val;
				this.getHistoryList();
			},
			getHistoryList(){
				let param = {
					doctorNo:window.sessionStorage.getItem("currentCompany"),
					current:this.historyPage,
					size:this.pageSize,
					type:3,
					condition:this.filters.historyFilter
				};
				this.secondListLoading = true;
				getTrackingList(param).then((data)=>{
					this.secondListLoading = false;
					if(data.status===200){
						this.inboundHistory = data.result.records;
						this.historyTotal = data.result.total;
					}
				})
			},
			showImport(){
				getBatchNumber().then((data)=>{
					if(data.status===200){
						this.importTrack.batchNumber = data.result.batchNumber;
						this.warehouseImportVisible = true;
					}else{
						this.$message.error(data.message);
					}

				})
			},
			removeRow(row){
				this.importTrack.trackingNumbers.splice(this.importTrack.trackingNumbers.indexOf(row),1);
			},
			removeAllItem(){
				this.importTrack.trackingNumbers.splice(0)
			},
			removeItem(row){
				this.bulkConfirmList.splice(this.bulkConfirmList.indexOf(row),1);
			},
			importFromText(){
				/*let row = [];
                let lines = this.text.split("\n");
                lines.filter((line)=>{
                    return line.trim()!=='';
                }).forEach((line)=>{
                    let obj = {};
                    let columns = line.split(",");
                    obj.tracking = columns[0]?columns[0]:"";
                    obj.upc = columns[1]?columns[1]:"";
                    obj.qty = columns[2]?columns[2]:"";
                    obj.note = columns[3]?columns[3]:"";
                    row.push(obj);
                });
                this.importTrack.trackingNumbers.push.apply(this.importTrack.trackingNumbers,row);
                this.text = "";
                this.textImportVisible = false;*/

				let text = this.text.trim();
				if(!text){
					this.$message.error("Please enter import text.")
					return;
				}
				let row = [];
				let trackings = [];
				let existTrackings = [];
				let lines = text.split("\n");
				lines.filter((line)=>{
					return line.trim()!=='';
				}).forEach((line)=>{
					let obj = {};
					let columns = [];
					if(line.indexOf(" ")!==-1){
						columns = line.split(" ");
					}else if(line.indexOf("\t")!==-1){
						columns = line.split("\t");
					}else if(line.indexOf(",")!==-1){
						columns = line.split(",");
					}
					obj.tracking = columns[0]?columns[0].trim():"";
					obj.upc = columns[1]?columns[1].trim():"";
					obj.qty = columns[2]?columns[2].trim():"";
					obj.note = columns[3]?columns[3].trim():"";

					let existInput = trackings.find((item)=>{
						return item.tracking===obj.tracking&&item.upc===obj.upc&&item.qty===obj.qty;
					});
					if(existInput){
						existTrackings.push(obj.tracking);
					}

					let exist = this.importTrack.trackingNumbers.find((item)=>{
						return item.tracking===obj.tracking&&item.upc===obj.upc&&item.qty===obj.qty;
					});
					if(!exist){
						trackings.push(obj)
					}else{
						existTrackings.push(obj.tracking);
					}
				});
				//this.warehouseConfirm.trackingNumbers = this.warehouseConfirm.trackingNumbers.concat(row);

				if(existTrackings.length>0){
					this.$message.error("Same data tracking for \""+existTrackings.join(", ")+"\" exists, please check.")
					return;
				}
				this.text = "";
				this.importTrack.trackingNumbers.push.apply(this.importTrack.trackingNumbers,trackings);
				this.textImportVisible = false;
			},
			editInboundHistory(row) {
				// this.editInbound = row;
				this.editInboundHistoryVisible = true;
                this.editInbound={};
                this.editInbound=JSON.parse(JSON.stringify(row));
            },
			confirmWarehouseItem(row) {
				this.importTrack.company = row.company;
				this.importTrack.warehouse = row.warehouse;
				this.importTrack.price = row.price;
				this.importTrack.quantity = row.quantity;
				this.importTrack.product = row.product;
				this.warehouseConfirmVisible = true;
			}
		},
		mounted() {
			this.getWarehouses();
			this.getToConfirmTrackingList();
			this.getHistoryList();
			//this.getInboundHistoryList();

            let user = sessionStorage.getItem('user')
            user = JSON.parse(user);
            this.user = user;
		}
	}

</script>
<style>
</style>


// WEBPACK FOOTER //
// Inbound.vue?e0eb241a